import React from 'react';
import styled from '@emotion/styled';
import { BigPlayButton, Player } from 'video-react';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';

export interface AttributeValues {
  backgroundImage?: string;
  backgroundVideo?: string;
  textColor?: string;
  title?: string;
  ctaText?: string;
  describeText?: string;
  describeText2?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  height?: string;
}

export const PreviewPromotion = (props: PreviewProps) => {
  const { values, height } = props;
  const { backgroundImage, backgroundVideo, describeText, describeText2 } = values;
  const isDefaultImage = !(backgroundVideo || backgroundImage);

  const viewImageOrVideo = () => {
    return backgroundVideo ? (
      <div className="style-video">
        <Player autoPlay playsInline src={backgroundVideo} fluid={false} width={225} height={300}>
          <BigPlayButton position="center" />
        </Player>
      </div>
    ) : (
      <img className="image-promotion" src={backgroundImage} alt="" />
    );
  };

  return (
    <StyledPromotionPreview
      className={!isDefaultImage ? 'background-none' : 'background-white'}
      style={{ height: height || '300px', backgroundColor: '#fff' }}
    >
      <div>
        <div className={!isDefaultImage ? 'preview-ant-image' : 'preview-ant-image image-border'}>
          <StyledLinearGradient />
          {!isDefaultImage ? (
            viewImageOrVideo()
          ) : (
            <div className="image-default">
              <img src={UploadImage} alt="" />
              <div className="describeText">{describeText}</div>
              <div className="describeText2">{describeText2}</div>
            </div>
          )}
        </div>
      </div>
    </StyledPromotionPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledPromotionPreview = styled.div`
  margin-top: 2rem;
  margin-left: 3.8rem;
  min-height: 293px;
  width: 225px;
  position: relative;
  text-align: left;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  & .heading {
    margin-top: 16px;
    font-weight: 700;
    font-size: 17px;
    padding: 0 1rem;
  }
  & .image-border {
    border: 1px #000 solid;
  }
  & .background-none {
    background: none !important;
  }
  & .background-white {
    background-color: #ffffff;
  }
  & .preview-ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 300px;
    & .image-promotion {
      width: 100%;
      height: 300px;
    }
    & .image-default {
      justify-content: center;
      text-align: center;
      margin-top: 2rem;
      & img {
        width: 6rem;
        height: 6rem;
      }
      & .describeText {
        font-size: 17px;
        padding-top: 1rem;
        font-weight: 600;
      }
      & .describeText2 {
        font-size: 15px;
        padding-top: 0.5rem;
      }
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-brand {
    margin: 0.7rem 1rem;
    & .logo-tm {
      width: 2.5rem;
      padding-right: 10px;
      height: auto;
    }
    & .img-partner {
      padding-left: 10px;
      width: auto;
      max-height: 3rem;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
